import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import BarreNav from '../components/BarreNav';
import { CHOIX, lireTheme, definirTheme } from '../services/theme';

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [theme, setTheme] = useState(lireTheme);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initiales = `${user?.prenom?.[0] || ''}${user?.nom?.[0] || ''}`.toUpperCase();

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="back-btn" onClick={() => navigate('/planning')}>‹</div>
        <div className="topbar-title">Mon compte</div>
      </div>

      <div className="content">
        {/* Avatar + nom */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '32px 0 24px' }}>
          <div style={{
            width: 80, height: 80, borderRadius: '50%',
            background: 'linear-gradient(135deg, #185FA5, #D42B2B)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 32, fontWeight: 800, color: '#fff', marginBottom: 14,
          }}>
            {initiales}
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--texte)' }}>
            {user?.prenom} {user?.nom}
          </div>
          <div style={{ fontSize: 13, color: 'var(--texte-doux)', marginTop: 4 }}>
            {user?.secteur || 'Technicien FTTH'}
          </div>
        </div>

        {/* Infos compte */}
        <div className="section-card">
          <div className="section-label">Informations du compte</div>
          {[
            ['Prénom', user?.prenom],
            ['Nom', user?.nom],
            ['Login', user?.login],
            ['Secteur', user?.secteur || '—'],
            ['Identifiant Zoho', user?.zoho_nom || '—'],
          ].map(([label, value]) => (
            <div key={label} className="info-row">
              <span className="info-key">{label}</span>
              <span className="info-val">{value}</span>
            </div>
          ))}
        </div>

        {/* Réglages */}
        <div className="section-card">
          <div className="section-label">Réglages</div>
          <div style={{ fontSize: 14, color: 'var(--texte)', marginBottom: 4 }}>Apparence</div>
          <div style={{ fontSize: 12, color: 'var(--texte-doux)', marginBottom: 10 }}>
            « Système » suit le réglage de votre téléphone et bascule seul le soir.
          </div>
          <div style={{ display: 'flex', gap: 6 }}>
            {CHOIX.map(c => {
              const actif = c.valeur === theme;
              return (
                <button
                  key={c.valeur}
                  onClick={() => { definirTheme(c.valeur); setTheme(c.valeur); }}
                  aria-pressed={actif}
                  style={{
                    flex: 1, padding: '9px 6px', fontSize: 13, fontWeight: 600, borderRadius: 10,
                    border: `1px solid ${actif ? 'var(--accent)' : 'var(--bord-fort)'}`,
                    background: actif ? 'var(--accent-plein)' : 'var(--surface)',
                    color: actif ? '#fff' : 'var(--accent)', cursor: 'pointer',
                  }}
                >{c.libelle}</button>
              );
            })}
          </div>
        </div>

        {/* Déconnexion */}
        <button
          onClick={handleLogout}
          style={{
            width: '100%', padding: '14px', marginTop: 24,
            background: 'var(--surface)', color: 'var(--danger)',
            border: '1.5px solid var(--danger)', borderRadius: 14,
            fontSize: 15, fontWeight: 700, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          }}
        >
          <span>↩</span> Se déconnecter
        </button>

        <div style={{ height: 16 }} />
      </div>

      <BarreNav actif="profil" />
    </div>
  );
}
